export default __webpack_public_path__ + "static/media/BETH.b07995b6.png";